import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { fdatetime } from "@/lib/api";

export function NotificationBell({ client, testId = "notification-bell" }) {
  const [d, setD] = useState({ items: [], unread: 0 });
  const navigate = useNavigate();
  const load = useCallback(async () => { try { setD((await client.get("/notifications")).data); } catch { /* silent */ } }, [client]);
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);
  const open = async (n) => {
    await client.post("/notifications/read", { ids: [n.id] }).catch(() => {});
    load();
    if (n.link) navigate(n.link);
  };
  const readAll = async () => { await client.post("/notifications/read", {}).catch(() => {}); load(); };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid={testId} className="relative inline-flex h-10 w-10 items-center justify-center rounded-full text-slate-600 transition-colors hover:bg-slate-100" aria-label="Notifications">
          <Bell className="h-5 w-5" />
          {d.unread > 0 && <span data-testid={`${testId}-count`} className="absolute right-0 top-0 min-w-[18px] rounded-full bg-rose-600 px-1 text-center text-[10px] font-semibold leading-[18px] text-white">{d.unread > 99 ? "99+" : d.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid={`${testId}-panel`}>
        <div className="flex items-center justify-between border-b border-slate-100 px-4 py-2.5">
          <span className="text-sm font-semibold text-slate-900">Notifications</span>
          {d.unread > 0 && <button data-testid={`${testId}-read-all`} onClick={readAll} className="text-xs font-medium text-[#389F95] hover:underline">Mark all read</button>}
        </div>
        <ul className="max-h-96 divide-y divide-slate-100 overflow-y-auto">
          {d.items.length === 0 && <li className="px-4 py-6 text-center text-sm text-slate-400">You're all caught up.</li>}
          {d.items.map((n) => (
            <li key={n.id}>
              <button data-testid={`notification-${n.id}`} onClick={() => open(n)} className={`block w-full px-4 py-3 text-left transition-colors hover:bg-slate-50 ${n.read ? "" : "bg-teal-50/50"}`}>
                <div className="flex items-start gap-2">{!n.read && <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-[#45BFB4]" />}
                  <div className="min-w-0"><div className="text-sm font-medium text-slate-900">{n.title}</div><div className="text-xs text-slate-500">{n.message}</div>
                    <div className="mt-1 text-[11px] text-slate-400">{fdatetime(n.created_at)}</div></div></div>
              </button>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
